import { render, staticRenderFns } from "./nature.vue?vue&type=template&id=504a65f8&scoped=true&"
import script from "./nature.vue?vue&type=script&lang=js&"
export * from "./nature.vue?vue&type=script&lang=js&"
import style0 from "./nature.vue?vue&type=style&index=0&id=504a65f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a65f8",
  null
  
)

export default component.exports